import React from 'react';
import { Link } from 'react-router-dom';

export default function CtaBand({ heading, sub, linkTo, linkLabel }) {
  const isExternalLink = typeof linkTo === 'string'
    && /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(linkTo);

  return (
    <section className="cta-band">
      <div className="container">
        <h2>{heading}</h2>
        <p style={{ color: '#bfd2f0', marginBottom: 28 }}>{sub}</p>
        {isExternalLink ? (
          <a className="btn btn-orange" href={linkTo}>{linkLabel}</a>
        ) : (
          <Link className="btn btn-orange" to={linkTo}>{linkLabel}</Link>
        )}
      </div>
    </section>
  );
}
